<template>
  <div>
    <v-row v-if="domainLoaded && domain.load_error">
      <v-col>
        <gg-card>
          <gg-card-header>
            Error
          </gg-card-header>
          <gg-card-text>
            {{ domain.load_error }}
          </gg-card-text>
        </gg-card>
      </v-col>
    </v-row>
    <v-row v-else align="stretch">
      <v-col cols="12" sm="6">
        <gg-card height="100%">
          <gg-card-header>
            {{ `Information - ${domain.domain}` }}
          </gg-card-header>
          <gg-card-text>
            <v-row>
              <v-col class="py-1" cols="8">
                Status
              </v-col>
              <v-col cols="4" class="py-1 d-inline-flex text-right">
                  <v-icon
                    small
                    class="pb-1 pr-1"
                    :color="statusColor(domain.status)"
                  >
                    mdi-circle
                  </v-icon>
                  {{ domain.status }}
              </v-col>
            </v-row>

            <v-divider />

            <v-row>
              <v-col class="py-1" cols="8">
                Registration Date:
              </v-col>
              <v-col cols="4" class="py-1 d-inline-flex text-right">
                <span>{{ domain.whmcs_registrationdate }}</span>
              </v-col>
            </v-row>

            <v-divider />

            <v-row>
              <v-col cols="8" class="py-1">
                Expiry Date:
              </v-col>
              <v-col cols="4" class="py-1 d-inline-flex text-right">
                <span>{{ domain.whmcs_nextduedate }}</span>
              </v-col>
            </v-row>

            <v-divider/>

            <v-row>
              <v-col class="py-1" cols="8">Renewal Amount:</v-col>
              <v-col class="py-1 d-inline-flex text-right" cols="4">
                <span>${{ domain.whmcs_recurringamount }}</span>
              </v-col>
            </v-row>

            <v-divider />

            <v-row>
              <v-col cols="8" class="py-1">
                Auto Renew:
              </v-col>
              <v-col cols="4" class="py-1 d-inline-flex">
                <div v-if="cancellationData.autorenew">
                  <div>
                    <v-icon small class="pb-1" style="color:#4caf50;">
                      mdi-circle
                    </v-icon> On
                    <router-link :to="{ name: 'cancel', params: { service_id: cancellationData.id }, query: { type: cancellationTypes.DOMAIN }}">
                      <v-icon size="20" color="blue">mdi-autorenew</v-icon> Disable
                    </router-link>
                  </div>
                </div>
                <div v-else>
                  <div>
                    <v-icon small class="pb-1" style="color:red;">
                      mdi-circle
                    </v-icon> Off
                    <a href="#" @click="canAutorenewProceed">
                    <v-icon size="20" color="blue">mdi-autorenew</v-icon> Enable
                  </a>
                  </div>
                </div>
              </v-col>
            </v-row>
          </gg-card-text>
        </gg-card>
      </v-col>

      <v-col cols="12" sm="6">
        <gg-card height="100%">
          <gg-card-header>
            Domain options
          </gg-card-header>
          <gg-card-text>
            <v-row>
              <registar-lock :domainid="domainid"/>
<!--              <auto-renew :domainid="domainid"/>-->
              <id-protect :domainid="domainid"/>
            </v-row>
          </gg-card-text>
        </gg-card>
      </v-col>
    </v-row>
    <gg-modal :is-active="autorenewModalOpen" @close="closeModalAutorenew">
      <template v-slot:toolbar>
        Enabling auto renew error
      </template>
      <template v-slot:body>
        Your domain is not eligible to enable auto renew. Please contact Billing for assistance.
      </template>
      <template v-slot:actions>
        <gg-btn @click="closeModalAutorenew">Close</gg-btn>
      </template>
    </gg-modal>
    <gg-modal :is-active="autorenewModalConfirmOpen" @close="closeModalAutorenewConfirm">
      <template v-slot:toolbar>
        Enabling auto renew
      </template>
      <template v-slot:body>
        <p>This service will be set to auto-renew. Our system will automatically renew your account to ensure your account stays active.</p>

        <p>Are you sure you want to enable auto renewal?</p>
      </template>
      <template v-slot:actions>
        <gg-btn secondary @click="closeModalAutorenewConfirm">No</gg-btn>
        <gg-btn primary :loading="autorenewLoading" @click="acceptModalAutorenewConfirm">Yes</gg-btn>
      </template>
    </gg-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import RegistarLock from '@/components/Domains/DomainOptions/RegistarLock'
// import AutoRenew from '@/components/Domains/DomainOptions/AutoRenew'
import IdProtect from '@/components/Domains/DomainOptions/IdProtect'
import { cancellationTypes } from '@/consts/cancellations'

export default {
  name: 'DomainInfo',
  props: {
    domainid: {
      type: String,
      required: true
    }
  },
  components: {
    RegistarLock,
    // AutoRenew,
    IdProtect
  },
  data () {
    return {
      autorenewModalOpen: false,
      cancellationTypes,
      autorenewModalConfirmOpen: false,
      autorenewLoading: false,
    }
  },
  methods: {
    ...mapActions(['enableAutorenew']),
    statusColor (status) {
      return status === 'Active' ? 'green' : 'orange lighten-1'
    },
    goToCancellation () {
      if (this.cancellationData.cancellation_pending) {
        this.$router.push(`/cancellations/${this.cancellationData.cancellation_id}`)
      } else {
        this.$router.push({
          name: 'cancel',
          params: {
            service_id: this.domainid,
          },
          query: {
            type: 'domain'
          }
        })
      }
    },

    closeModalAutorenew () {
      this.autorenewModalOpen = false
    },
    openModalAutorenew () {
      this.autorenewModalOpen = true
    },
    canAutorenewProceed () {
      if (!this.cancellationData.can_enable_autorenew) {
        this.openModalAutorenew()
        return
      }
      this.openModalAutorenewConfirm()
    },
    async callEnableAutorenew () {
      await this.enableAutorenew({ service_id: this.cancellationData.id, service_type: cancellationTypes.DOMAIN, cancellation_id: this.cancellationData.cancellation_id })
    },
    closeModalAutorenewConfirm () {
      this.autorenewModalConfirmOpen = false
    },
    openModalAutorenewConfirm () {
      this.autorenewModalConfirmOpen = true
    },
    async acceptModalAutorenewConfirm () {
      this.autorenewLoading = true
      try {
        await this.callEnableAutorenew()
      } finally {
        this.autorenewLoading = false
      }
      this.closeModalAutorenewConfirm()
    },
  },
  computed: {
    ...mapGetters(['domain', 'domainPopulated', 'domains']),
    cancellationData () {
      const { cancellation_id, cancellation_pending, autorenew, can_auto_renew, id, can_enable_autorenew } =
        this.domains.find((domain) => domain.id === this.domain.id)

      return {
        cancellation_id, cancellation_pending, autorenew, can_auto_renew, id, can_enable_autorenew
      }
    },
    domainLoaded () {
      return !!Object.keys(this.domain).length
    }
  }
}
</script>

<style lang="scss">
  .same-height {
    height: 100%;
  }
</style>
